/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AesGcmEncryptResponse
 */
export interface AesGcmEncryptResponse {
    /**
     * 
     * @type {string}
     * @memberof AesGcmEncryptResponse
     */
    cipher: string;
    /**
     * 
     * @type {string}
     * @memberof AesGcmEncryptResponse
     */
    tag: string;
    /**
     * 
     * @type {string}
     * @memberof AesGcmEncryptResponse
     */
    cryptographicNonce: string;
}

/**
 * Check if a given object implements the AesGcmEncryptResponse interface.
 */
export function instanceOfAesGcmEncryptResponse(value: object): value is AesGcmEncryptResponse {
    if (!('cipher' in value) || value['cipher'] === undefined) return false;
    if (!('tag' in value) || value['tag'] === undefined) return false;
    if (!('cryptographicNonce' in value) || value['cryptographicNonce'] === undefined) return false;
    return true;
}

export function AesGcmEncryptResponseFromJSON(json: any): AesGcmEncryptResponse {
    return AesGcmEncryptResponseFromJSONTyped(json, false);
}

export function AesGcmEncryptResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AesGcmEncryptResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'cipher': json['cipher'],
        'tag': json['tag'],
        'cryptographicNonce': json['cryptographicNonce'],
    };
}

export function AesGcmEncryptResponseToJSON(json: any): AesGcmEncryptResponse {
    return AesGcmEncryptResponseToJSONTyped(json, false);
}

export function AesGcmEncryptResponseToJSONTyped(value?: AesGcmEncryptResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'cipher': value['cipher'],
        'tag': value['tag'],
        'cryptographicNonce': value['cryptographicNonce'],
    };
}

